import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { latestDate } from "../../../../sharedComponent/common";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import Import from "../../../../assets/images/ic-Import.svg";
import ApiConfig from "../../../../api/ApiConfig";
import { getWithAuthCall, simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const VehiclesBasedStatus = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [VehicleId, setVehicleId] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [period, setPeriod] = useState("day");
  const [currentDate, setCurrentDate] = useState({ toDayDate: new Date() });
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);
  const maxDate = new Date();

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    getVehicleList();
  }, []);

  function getVehicleList() {
    getWithAuthCall(ApiConfig.VEHICEL_AVALIVALITY_DROPDAWAN)
      .then((data) => setVehicleList(data?.data || []))
      .catch((err) => console.log("api err", err));
  }

  useEffect(() => {
    fetchReport();
  }, [VehicleId, statusFilter, period, currentDate, OptionDownload]);

  // Compute start/end date range based on the Day / Week / Month selection
  // (same approach used by the other day-week-month reports).
  const getDateRange = () => {
    const d = new Date(currentDate.toDayDate);
    let start = new Date(d);
    let end = new Date(d);
    if (period === "week") {
      end.setDate(end.getDate() + 6);
    } else if (period === "month") {
      start = new Date(d.getFullYear(), d.getMonth(), 1);
      end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    }
    return {
      startdate: latestDate(start, "yyyy-MM-dd"),
      enddate: latestDate(end, "yyyy-MM-dd"),
    };
  };

  const fetchReport = () => {
    const { startdate, enddate } = getDateRange();
    const body = {
      runningStatus: statusFilter,
      format: OptionDownload,
      vehicle_id: VehicleId,
      report_date: latestDate(currentDate.toDayDate, "yyyy-MM-dd"),
      day_week_month: period,
      startdate,
      enddate,
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(
      ApiConfig.VEHICLES_BASED_STATUS_REPORT,
      JSON.stringify(body)
    )
      .then((res) => {
        if (res?.result) setOrderListData(res?.listData || []);
        else setOrderListData([]);
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>
                    {t("Date:")} {latestDate(currentDate.toDayDate, "yyyy-MM-dd")}
                  </p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Vehicle list")}
                  onChange={(value) => setVehicleId(value)}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Vehicle")}
                  </Option>
                  {vehicleList?.map((vehicle) => (
                    <Option
                      key={vehicle.vehicle_id}
                      value={vehicle.vehicle_id}
                      label={vehicle.vehicle_number}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {vehicle.vehicle_number}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "150px" }}
                  className="custom-select"
                  placeholder={t("Status")}
                  value={statusFilter}
                  onChange={(value) => setStatusFilter(value)}
                >
                  <Option value="All" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("All Status")}
                  </Option>
                  <Option value="Running" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Running")}
                  </Option>
                  <Option value="Parked" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Parked")}
                  </Option>
                  <Option value="Idle" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Idle")}
                  </Option>
                  <Option value="Untracked" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Untracked")}
                  </Option>
                </Select>
              </div>

              <div className="innerSelectBox weekCounter datepicker-main">
                <CommonDatePicker
                  dateKey={"toDayDate"}
                  setDate={setCurrentDate}
                  data={currentDate}
                  SetPlaceholder={t("Today Date")}
                  dataDisbal={maxDate}
                />
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "120px" }}
                  className="custom-select"
                  placeholder={t("Day")}
                  value={period}
                  onChange={(value) => setPeriod(value)}
                >
                  <Option value="day" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Day")}
                  </Option>
                  <Option value="week" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Week")}
                  </Option>
                  <Option value="month" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Month")}
                  </Option>
                </Select>
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (columns mapped to API response, matches reference UI) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("Vehicle Number")}</th>
                  <th>{t("Vehicle Registration Number")}</th>
                  <th>{t("Vehicle IMEI")}</th>
                  <th>{t("Date")}</th>
                  <th>{t("Last Tracked")}</th>
                  <th>{t("Action")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>{item.vehicle_number}</td>
                          <td>{item.vehicle_reg_no}</td>
                          <td>{item.vehicle_imei}</td>
                          <td>
                            {latestDate(currentDate.toDayDate, "yyyy-MM-dd")}
                          </td>
                          <td>
                            {item.last_tracked && item.last_tracked !== ""
                              ? item.last_tracked
                              : "(not set)"}
                          </td>
                          <td>
                            <Link
                              to={"/VehicleDetails/" + (item.vehicle_id || "")}
                              className="btn btn-success btn-sm"
                              title={t("View")}
                            >
                              <i className="fa fa-search-plus"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default VehiclesBasedStatus;
